import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";

import { environment } from "./environments/environment";
import { AppSetupProvider } from "./app/app-initializer";
import { CookiesConsentProviders } from "./app/cookies-consent-providers";
import { API_BASE_URL } from "./app/services/BackendClient";
import {
  AuthenticationServiceProvider,
  AuthServiceDependencies,
} from "./app/services/AuthenticationServiceProvider";
import { BackendClientProvider, BackendClientFactory } from "./app/services/BackendClientProvider";
import { AuthenticationServiceFactory } from "./app/global";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {
  MsalInterceptor,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
} from "@azure/msal-angular";
import {
  MSALInstanceFactory,
  MSALGuardConfigFactory,
  MSALInterceptorConfigFactory,
} from "./app/services/msal/msal-config";
import { IbanService } from "./app/services/IbanService";
import { LoggingService } from "./app/services/logging.service";
import { BackendValidationParserService } from "./app/services/backend-validation-parser.service";
import { DatePipe } from "@angular/common";
import { ComplaintStatusPipe } from "./app/shared/pipes/complaint-status.pipe";
import { AlertService } from "./app/b2b/ops/shared/services/alert.service";
import { BuildVersionService } from "./app/b2b/ops/shared/services/build-version.service";
import { UpToDateBuildService } from "./app/b2b/ops/shared/services/up-to-date.service";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { DialogService, DynamicDialogModule } from "primeng/dynamicdialog";
import { appConfig } from "./app.config";
import { ComplaintService } from "./app/case-submission/shared/services/complaint.service";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    ...appConfig.providers,
    DialogService,
    importProvidersFrom(BrowserModule, DynamicDialogModule),
    AppSetupProvider,
    ...CookiesConsentProviders,
    {
      provide: API_BASE_URL,
      useValue: environment.API_BASE_URL,
    },
    {
      provide: AuthServiceDependencies,
      useClass: AuthServiceDependencies,
    },
    {
      provide: BackendClientProvider,
      useFactory: BackendClientFactory,
    },
    {
      provide: AuthenticationServiceProvider,
      useFactory: AuthenticationServiceFactory,
      deps: [AuthServiceDependencies],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    IbanService,
    ComplaintService,
    LoggingService,
    BackendValidationParserService,
    DatePipe,
    ComplaintStatusPipe,
    AlertService,
    BuildVersionService,
    UpToDateBuildService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
